export default __webpack_public_path__ + "static/media/sustainability14.1ca9e16a.webp";